'use strict';

var StrategyListingService = function StrategyListingService(Restangular, $q) {
  var strategyService = Restangular.one('rules').one('strategy');
  function removeStrategies(strategiesToRemove) {
    var promises = [];
    strategiesToRemove.forEach(function (strategy) {
      promises.push(strategyService.one(strategy.technicalId).remove());
    });
    return $q.all(promises);
  }
  return {
    removeStrategies: removeStrategies
  };
};
StrategyListingService.$inject = ['Restangular', '$q'];
module.exports = StrategyListingService;